import React from 'react';
import GenericCadastroPage from './GenericCadastroPage';

export default function ComarcaVaraPage() {
  const columns = [
    { key: 'nome_comarca', label: 'Comarca' },
    { key: 'nome_vara', label: 'Vara' },
    { key: 'estado', label: 'Estado' },
    { key: 'cidade', label: 'Cidade' },
  ];

  const fields = [
    { name: 'nome_comarca', label: 'Nome da Comarca', required: true },
    { name: 'nome_vara', label: 'Nome da Vara', required: true },
    { name: 'estado', label: 'Estado', required: false },
    { name: 'cidade', label: 'Cidade', required: false },
  ];

  return (
    <GenericCadastroPage
      title="Comarcas e Varas"
      description="Gerencie as comarcas e varas cadastradas."
      tableName="comarca_vara_v2"
      columns={columns}
      fields={fields}
    />
  );
}